import { QUIZ_ROUTES } from "../homeDashboard/quizzes/quizRoutes";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import questionBankImg from "../assets/images/im2.png";
import testsImg from "../assets/images/im3.png";
import rapidFireImg from "../assets/images/im5.png";
import gamificationImg from "../assets/images/im6.png";

const fallbackQuizImages = [testsImg, questionBankImg, rapidFireImg, gamificationImg];

function resolveQuizRequestMode(routeKey) {
  const normalizedRouteKey = Number(routeKey);

  if (normalizedRouteKey === 2) {
    return 0;
  }

  if (normalizedRouteKey === 4) {
    return 2;
  }

  return 1;
}

const QuizCategory = ({
  open,
  onClose,
  navigationState = {},
  quizCategories = [],
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  const resolvedQuizOptions = (quizCategories || []).map((option, index) => ({
    ...option,
    title: option?.title || `Quiz Option ${index + 1}`,
    description:
      option?.description || "Select this quiz format to continue your preparation.",
    image: option?.category_image || fallbackQuizImages[index % fallbackQuizImages.length],
    routeKey: Number(option?.route_key || 0),
    backgroundColor: option?.background_color_code
      ? `#${String(option.background_color_code).replace(/^#/, "")}`
      : null,
    borderColor: option?.border_color_code
      ? `#${String(option.border_color_code).replace(/^#/, "")}`
      : null,
  }));

  const handleOpenOption = (option) => {
    navigate(QUIZ_ROUTES.list, {
      state: {
        ...navigationState,
        selectedQuizOption: option.title,
        selectedQuizOptionData: option,
        quizRequestParams: {
          category_id: Number(option?.category_id || option?.id || 1),
          route_key: Number(option?.routeKey || option?.route_key || 0),
          is_quiz: resolveQuizRequestMode(option?.routeKey || option?.route_key),
        },
      },
    });
    onClose?.();
  };

  return (
    <div className="quiz-category-popup" role="presentation" onClick={onClose}>
      <div
        className="quiz-category-popup__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quiz-category-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="quiz-category-popup__header">
          <div className="quiz-category-popup__heading">
            <span className="quiz-category-popup__icon" aria-hidden="true">
              <i className="bi bi-grid-fill" />
            </span>

            <div className="quiz-category-popup__text">
              <h2 id="quiz-category-title">Choose An Option Below</h2>
              <p>Select the format you want to continue with.</p>
            </div>
          </div>

          <button
            type="button"
            className="quiz-category-popup__close"
            aria-label="Close quiz category popup"
            onClick={onClose}
          >
            <i className="bi bi-x-lg" aria-hidden="true" />
          </button>
        </div>

        <div className="quiz-category-popup__body">
          {resolvedQuizOptions.length ? (
            resolvedQuizOptions.map((option) => (
              <button
                key={`${option.title}-${option.routeKey}`}
                type="button"
                className="quiz-category-popup__card"
                style={{
                  background: option.backgroundColor
                    ? `linear-gradient(180deg, ${option.backgroundColor} 0%, #ffffff 140%)`
                    : undefined,
                  borderColor: option.borderColor || undefined,
                }}
                onClick={() => handleOpenOption(option)}
              >
                <span className="quiz-category-popup__cardIcon">
                  <img src={option.image} alt="" aria-hidden="true" />
                </span>

                <span className="quiz-category-popup__cardCopy">
                  <span className="quiz-category-popup__cardTitle">{option.title}</span>
                  <span className="quiz-category-popup__cardDescription">{option.description}</span>
                </span>
              </button>
            ))
          ) : (
            <div className="quiz-category-popup__empty">
              <span className="quiz-category-popup__emptyIcon" aria-hidden="true">
                <i className="bi bi-grid-3x3-gap" />
              </span>
              <h3>No quiz categories available</h3>
              <p>Please try again in a moment.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuizCategory;
